import React from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { I18nextProvider } from 'react-i18next';
import { HashRouter } from 'react-router-dom';

import './styles.scss';
import './tailwind.css';
import './services/sentry';
import App from './App';
import ErrorBoundaryPage from './components/ErrorBoundaryPage';
import { I18NextNS } from './models/Language.model';
import { initPosthog } from './services/posthog';
import i18nUI from './translation/i18nUI';

initPosthog();

createRoot(document.getElementById('root')!).render(
  <ErrorBoundary fallback={<ErrorBoundaryPage />}>
    <I18nextProvider
      i18n={i18nUI}
      defaultNS={[I18NextNS.PAGES, I18NextNS.COMMON]}
    >
      <HashRouter>
        <App />
      </HashRouter>
    </I18nextProvider>
  </ErrorBoundary>,
);
